<div class="sidebar">
    <div class="sidebar__menu-box">
        <jep-dash-menu></jep-dash-menu>
    </div>
</div>